import React from "react";

export default function ScholarshipDetail({ title, desc }) {
  return (
    <div className=" w-80 flex flex-col gap-1 text-sm">
      <div>You could save up to</div>
      <p className="text-xl font-bold">MYR {title}</p>
      <div>Estimated nett course fee</div>
      <p className="text-3xl font-bold">MYR {desc}</p>
      <button className="bg-amber-400 text-white w-fit p-2 text-base">
        Secure your Offer
      </button>
    </div>
  );
}
